import { render } from "./Notes.vue?vue&type=template&id=43b2ccd0&scoped=true"
import script from "./Notes.vue?vue&type=script&lang=js"
export * from "./Notes.vue?vue&type=script&lang=js"

import "./Notes.vue?vue&type=style&index=0&id=43b2ccd0&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43b2ccd0"]])

export default __exports__